import { atom } from 'recoil';
import { createFieldSelector } from '@zurich/common/recoil';
import { localPartyInquirySubjectSelector } from '../selectors';
export const loaclAreaCodeAtom = atom({
    key: 'local/areaCodeAtom',
    default: null,
});
export const loaclPhoneNumberAtom = atom({
    key: 'local/PhoneNumberAtom',
    default: null,
});
export const loaclCountryCallingCodeAtom = atom({
    key: 'local/countryCallingCodeAtom',
    default: null,
});
export const localCustomerRequestsAtom = atom({
    key: 'local/localCustomerRequestsAtom',
    default: undefined,
});
const customerRequestSelectorHelper = createFieldSelector(localCustomerRequestsAtom);
// Message
export const localCustomerRequestsMessageSelector = customerRequestSelectorHelper('message', {
    defaultValue: {},
});
const localCustomerRequestsMessageSelectorHelper = createFieldSelector(localCustomerRequestsMessageSelector);
export const localCustomerRequestMessageCustomerRequestTypeSelector = localCustomerRequestsMessageSelectorHelper('customerRequestType', {
    defaultValue: undefined,
});
// Case: customerRequestType === 'GeneralRequest'
export const localCustomerRequestMessageSelector = localCustomerRequestsMessageSelectorHelper('message', {
    defaultValue: undefined,
});
// Contact
export const localCustomerRequestsContactSelector = customerRequestSelectorHelper('contact', {
    defaultValue: {},
});
export const localPartyTelephoneNumberAtom = atom({
    key: 'local/localPartyTelephoneNumber',
    default: undefined,
});
export const localPartyOnlineInquiryRadioAtom = atom({
    key: 'local/localPartyOnlineInquiryRadioAtom',
    default: 'email',
});
export const localPartyInquirySubjectAtom = atom({
    key: 'local/localPartyInquirySubjectAtom',
    default: localPartyInquirySubjectSelector,
});
export const localPartyPolicyNoAtom = atom({
    key: 'local/localPartyPolicyNoAtom',
    default: null,
});
export const localPartyClaimNoAtom = atom({
    key: 'local/localPartyClaimNoAtom',
    default: null,
});
export const localPartyInquiryType = atom({
    key: 'local/localPartyInquiryType',
    default: 'policy',
});
